import { HttpService } from './Http.service'
import { HttpErrorService } from '@/services/HttpError.service'
import { serviceErrorHandbook } from '@/models/Errors/serviceErrorHandbook'
import type { LayoutKit, LayoutSettings, VimeoApiAnswer } from '@/models'

export class LayoutService {
  private httpService: HttpService
  private httpErrorService: HttpErrorService<keyof typeof serviceErrorHandbook>

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(serviceErrorHandbook, 'utils')
  }

  async getVimeoPreview(videoId: string) {
    const url = `https://vimeo.com/api/v2/video/${videoId}.json`

    return await this.httpService
      .get<VimeoApiAnswer>(url, {
        requestConfig: {
          fullUrl: true,
          omitCredentials: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }

  async getLayoutSetting() {
    const url = '/content/layout'

    return await this.httpService
      .get<LayoutSettings>(url, {
        fetchConfig: { timeout: 3000 },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }

  async getLayoutKit() {
    const url = '/content/layout-kit'

    return await this.httpService
      .get<LayoutKit>(url, {
        requestConfig: {
          cache: {
            server: {
              lifeTime: getMilliseconds.inMinutes(5),
            },
          },
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }
}
